import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { Modal, Button } from 'react-bootstrap';
import { Checkbox, MenuItem } from '@mui/material';
import EditBtnCellRenderer from './editBtnCellRenderer';
import NotificationLogCellRenderer from '../../orders/clinicOrderGrid/notificationLogCellRenderer';

import { failedNotificationReports } from '../../../../services/clinicPortalServices/reportService';
import { getUserRole, getUserDetails } from '../../../../services/common/util';
import ReportsSearchMenu from './ReportsSearchMenu';
import AllGridViews from '../../orders/clinicOrderGrid/allGridViews';
import {
    getViewSettings,
    saveOrderSettings,
    deleteGridViewService,
    renameGridViewService,
    updateGridViewService
} from '../../../../services/clinicPortalServices/userViewSettings';
import { settingConstants } from '../../../../services/common/optionsData';
import toastr from 'toastr';
import Swal from 'sweetalert2';
import { getCompanyWithFacility } from '../../../../services/clinicPortalServices/companyServices';
import _ from 'lodash';
import { createAudit } from '../../../../services/clinicPortalServices/auditService';
import { auditEnums } from '../../../../services/common/constants';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class ClinicFailedNotificationReportsGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quickFilterText: '',
            isArchived: false,
            user_role: getUserRole(),
            isDateSave: false,
            showAllGridViews: false,
            isCreateDefault: true,
            isRenameView: false,
            isUpdateViews: false,
            showNameModal: false,
            newViewName: '',
            userId: window.localStorage.getItem('USER_ID'),
            selectedViewId: null,
            userSetting: {
                user_id: window.localStorage.getItem('USER_ID'),
                type: settingConstants.GRID,
                page: settingConstants.FAILED_SMS_EMAIL_REPORTS,
                grid_views: []
            },
            activeGridView: {
                _id: 0,
                name: '',
                search_filters: {
                    facility_id: [],
                    from_date: moment().subtract(0, 'days').format('YYYY-MM-DD') + 'T00:00',
                    to_date: moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00',
                    dateRange: 'today',
                    stateReportsType: 'all'
                },
                page_size: settingConstants.DEFAULT_PAGESIZE,
                columns: [],
                date_save: false
            },
            defaultGridView: {
                name: settingConstants.DEFAULT_VIEWNAME,
                search_filters: {
                    facility_id: [],
                    from_date: moment().subtract(0, 'days').format('YYYY-MM-DD') + 'T00:00',
                    to_date: moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00',
                    dateRange: 'today',
                    stateReportsType: 'all'
                },
                page_size: settingConstants.DEFAULT_PAGESIZE,
                columns: [],
                date_save: false
            },
            columnDefs: [
                {
                    headerName: 'Actions', colId: 'actions',
                    minWidth: 200,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'editBtnCellRenderer'
                },
                {
                    headerName: 'Requisition',
                    minWidth: 150,
                    field: 'lab_order_id'
                },
                {
                    headerName: 'Sample ID',
                    minWidth: 150,
                    field: 'test_info.sample'
                },
                {
                    headerName: 'Patient',
                    minWidth: 200,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.patient_id) {
                            return params.data.patient_id.first_name + ' ' + params.data.patient_id.last_name;
                        } else {
                            return '';
                        }
                    }
                },
                {
                    headerName: 'Facility',
                    minWidth: 150,
                    resizable: true,
                    field: 'facility_id.name'
                },
                {
                    headerName: 'Physician',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.provider) {
                            return params.data.provider.first_name + ' ' + params.data.provider.last_name;
                        } else {
                            return '';
                        }
                    }
                },
                {
                    headerName: 'Patient Double Failure',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: function addColumns(params) {
                        if (params.data.notification_state !== 'NO_ACTION') {
                            if (
                                params.data.sms_delivery_status !== 'delivered' &&
                                params.data.email_delivery_status !== 'delivered'
                            ) {
                                return 'YES';
                            } else {
                                return 'NO';
                            }
                        } else {
                            return 'Not Escalated';
                        }
                    }
                },
                {
                    headerName: 'Notification Log',
                    minWidth: 180,
                    field: 'notification_state',
                    cellRenderer: 'notificationLogCellRenderer',
                    resizable: true
                }
            ],
            paginationNumberFormatter: function (params) {
                return '[' + params.value.toLocaleString() + ']';
            },
            components: {
                editBtnCellRenderer: EditBtnCellRenderer,
                notificationLogCellRenderer: NotificationLogCellRenderer
            },
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this },
            excelStyles: [
                {
                    id: 'header',
                    interior: {
                        color: '#aaaaaa',
                        pattern: 'Solid'
                    }
                },
                {
                    id: 'body',
                    interior: {
                        color: '#dddddd',
                        pattern: 'Solid'
                    }
                }
            ],
            facilities: []
        };
        this.loadFacilities(this.state.isArchived);
    }

    loadFacilities = (isArchived) => {
        let { activeGridView } = this.state;
        let filters = activeGridView.search_filters;
        let facilities = this.state.facilities;

        let isAllFacilities = false;
        if (
            filters.facility_id.length > 0 &&
            filters.facility_id.length === facilities.length &&
            facilities.length > 0
        ) {
            isAllFacilities = true;
        }

        getCompanyWithFacility(isArchived).then((response) => {
            let facilityIds = [];

            facilities = response.data;

            if (facilities.length > 0) {
                facilities.map((fac) => {
                    facilityIds.push(fac._id);
                    return null;
                });
                this.facilityIds = facilityIds;
                const facilityIdStorage = window.localStorage.getItem('FACILITY_ID');
                if (isAllFacilities) {
                    filters.facility_id = facilityIds;
                } else if (
                    facilityIdStorage &&
                    facilityIdStorage !== undefined &&
                    Array.isArray(JSON.parse(facilityIdStorage)) &&
                    JSON.parse(facilityIdStorage).length > 0
                ) {
                    filters.facility_id = JSON.parse(facilityIdStorage);
                } else if (facilityIds.length >= 1) {
                    filters.facility_id = facilityIds;
                } else {
                    filters.facility_id = facilities[0]._id;
                }
            } else {
                filters.facility_id = [];
            }
            this.setState({ activeGridView, facilities }, () => {
                this.loadUserSetting(this.state.defaultGridView);
            });
        });
    };

    initDateRange = (grid_views) => {
        return grid_views.map((view) => {
            if (
                moment(view.search_filters.to_date).format('YYYY-MM-DD') ===
                moment().add(1, 'days').format('YYYY-MM-DD')
            ) {
                if (moment(view.search_filters.from_date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
                    view.search_filters.dateRange = 'today';
                } else if (
                    moment(view.search_filters.from_date).format('YYYY-MM-DD') ===
                    moment().startOf('week').format('YYYY-MM-DD')
                ) {
                    view.search_filters.dateRange = 'week';
                } else if (
                    moment(view.search_filters.from_date).format('YYYY-MM-DD') ===
                    moment().startOf('month').format('YYYY-MM-DD')
                ) {
                    view.search_filters.dateRange = 'month';
                } else if (
                    moment(view.search_filters.from_date).format('YYYY-MM-DD') ===
                    moment().startOf('quarter').format('YYYY-MM-DD')
                ) {
                    view.search_filters.dateRange = 'quarter';
                } else {
                    view.search_filters.dateRange = 'custom';
                }
            } else {
                view.search_filters.dateRange = 'custom';
            }
            return view;
        });
    };

    loadUserSetting = (defaultGridView) => {
        let { userId, userSetting, activeGridView } = this.state;
        let viewId = '';
        let params = {
            user_id: userId,
            type: settingConstants.GRID,
            page: settingConstants.FAILED_SMS_EMAIL_REPORTS
        };
        getViewSettings(params).then((response) => {
            if (response.data && response.data.length > 0) {
                userSetting = response.data[0];
                if (userSetting.grid_views.length > 0) {
                    viewId = window.localStorage.getItem('VIEW_FAILED_SMS_EMAIL_REPORTS');
                    userSetting.grid_views = this.initDateRange(userSetting.grid_views);
                    let activeGridViewTemp = viewId ? userSetting.grid_views.find((x) => x._id === viewId) : null;
                    activeGridView = activeGridViewTemp
                        ? _.cloneDeep(activeGridViewTemp)
                        : _.cloneDeep(userSetting.grid_views[0]);
                    window.localStorage.setItem('VIEW_FAILED_SMS_EMAIL_REPORTS', activeGridView._id);
                    if (activeGridView.name === 'Default') {
                        activeGridView.search_filters = _.cloneDeep(defaultGridView.search_filters);
                        activeGridView.search_filters.facility_id = this.facilityIds;
                    } else if (!activeGridView.date_save) {
                        activeGridView.search_filters.from_date = _.cloneDeep(defaultGridView.search_filters.from_date);
                        activeGridView.search_filters.to_date = _.cloneDeep(defaultGridView.search_filters.to_date);
                    }
                    this.setState({
                        activeGridView: activeGridView,
                        userSetting: userSetting
                    });
                    this.loadGridData(activeGridView.search_filters);
                } else {
                    this.createView(settingConstants.DEFAULT_VIEWNAME);
                }
            } else {
                this.createView(settingConstants.DEFAULT_VIEWNAME);
            }
        });
    };

    handleTabChange = (selectedViewId) => {
        let { activeGridView, defaultGridView, userSetting } = this.state;
        if (selectedViewId !== activeGridView._id && !selectedViewId.includes('_btn')) {
            let selectedGridView = userSetting.grid_views.find((view) => view._id === selectedViewId);
            window.localStorage.setItem('VIEW_FAILED_SMS_EMAIL_REPORTS', selectedViewId);
            if (selectedGridView.name === 'Default') {
                selectedGridView.search_filters = _.cloneDeep(defaultGridView.search_filters);
                selectedGridView.search_filters.facility_id = this.facilityIds;
            } else if (!activeGridView.date_save) {
                activeGridView.search_filters.from_date = _.cloneDeep(defaultGridView.search_filters.from_date);
                activeGridView.search_filters.to_date = _.cloneDeep(defaultGridView.search_filters.to_date);
            }
            this.setState({ activeGridView: _.cloneDeep(selectedGridView) });
            this.loadGridData(selectedGridView.search_filters);
        }
    };

    onIsArchivedInformation = (event) => {
        this.setState({ isArchived: event.target.checked });
        this.loadFacilities(event.target.checked);
    };

    updateDateRange = (dateRange) => {
        let { activeGridView } = this.state;
        let filters = activeGridView.search_filters;
        if (activeGridView.search_filters.dateRange !== dateRange) {
            switch (dateRange) {
                case 'today':
                    filters.to_date = moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00';
                    filters.from_date = moment().format('YYYY-MM-DD') + 'T00:00';
                    activeGridView.search_filters.dateRange = dateRange;
                    break;
                case 'week':
                    filters.to_date = moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00';
                    filters.from_date = moment().startOf('week').format('YYYY-MM-DD') + 'T00:00';
                    activeGridView.search_filters.dateRange = dateRange;
                    break;
                case 'month':
                    filters.to_date = moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00';
                    filters.from_date = moment().startOf('month').format('YYYY-MM-DD') + 'T00:00';
                    activeGridView.search_filters.dateRange = dateRange;
                    break;
                case 'quarter':
                    filters.to_date = moment().add(1, 'days').format('YYYY-MM-DD') + 'T00:00';
                    filters.from_date = moment().startOf('quarter').format('YYYY-MM-DD') + 'T00:00';
                    activeGridView.search_filters.dateRange = dateRange;
                    break;
                default:
                    break;
            }
            this.setState({ activeGridView });
            if (dateRange !== 'custom') {
                this.loadGridData(filters);
            }
        }
    };

    setDateRange = (gridView) => {
        if (
            moment(gridView.search_filters.to_date).format('YYYY-MM-DD') ===
            moment().add(1, 'days').format('YYYY-MM-DD')
        ) {
            if (moment(gridView.search_filters.from_date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
                gridView.search_filters.dateRange = 'today';
            } else if (
                moment(gridView.search_filters.from_date).format('YYYY-MM-DD') ===
                moment().startOf('week').format('YYYY-MM-DD')
            ) {
                gridView.search_filters.dateRange = 'week';
            } else if (
                moment(gridView.search_filters.from_date).format('YYYY-MM-DD') ===
                moment().startOf('month').format('YYYY-MM-DD')
            ) {
                gridView.search_filters.dateRange = 'month';
            } else if (
                moment(gridView.search_filters.from_date).format('YYYY-MM-DD') ===
                moment().startOf('quarter').format('YYYY-MM-DD')
            ) {
                gridView.search_filters.dateRange = 'quarter';
            } else {
                gridView.search_filters.dateRange = 'custom';
            }
        } else {
            gridView.search_filters.dateRange = 'custom';
        }
    };

    handleDateFiltersChange = (dateTime, type) => {
        let { activeGridView } = this.state;
        const filters = activeGridView.search_filters;
        let filterIsValid = true;
        if (type === 'from_date') {
            if (moment(filters.to_date).isAfter(dateTime)) {
                filters.from_date = dateTime;
            } else {
                filterIsValid = false;
            }
        } else {
            if (moment(dateTime).isAfter(filters.from_date)) {
                filters.to_date = dateTime;
            } else {
                filterIsValid = false;
            }
        }

        if (filterIsValid) {
            this.setDateRange(activeGridView);
            this.setState({ activeGridView });
            this.loadGridData(filters);
        }
    };

    handleFiltersChange = (e) => {
        let { activeGridView, facilities } = this.state;
        let filters = activeGridView.search_filters;

        switch (e.target.name) {
            case 'type': {
                filters.stateReportsType = e.target.value;
                break;
            }
            case 'facility_id': {
                let facilityIdChanged = [],
                    isAdded = false,
                    facilitiesIn = [],
                    facilityIdsTemp = [];
                let newFacilityIds = e.target.value;
                if (e.target.value.includes('all')) {
                    if (filters.facility_id.length === this.facilityIds.length) {
                        filters.facility_id = [];
                    } else {
                        filters.facility_id = _.cloneDeep(this.facilityIds);
                    }
                } else {
                    if (filters.facility_id.length > newFacilityIds.length) {
                        facilityIdChanged = filters.facility_id.find((val) => !newFacilityIds.includes(val));
                    } else {
                        facilityIdChanged = newFacilityIds.find((val) => !filters.facility_id.includes(val));
                        isAdded = true;
                    }
                    let facilityChanged = facilities.find((facility) => facility._id === facilityIdChanged);
                    facilityIdsTemp = _.cloneDeep(filters.facility_id);
                    // If company is changed
                    if (facilityChanged.type === 'company') {
                        let companyChanged = facilityChanged;
                        facilities.forEach((fac) => {
                            if (fac.parent_id === companyChanged._id) {
                                facilitiesIn.push(fac._id);
                            }
                        });
                        let index = facilityIdsTemp.indexOf(companyChanged._id);
                        if (facilitiesIn.length > 0) {
                            // If company is selected
                            if (isAdded) {
                                // Add company Id
                                facilityIdsTemp.push(companyChanged._id);
                                // Add facility Ids
                                facilitiesIn.forEach((facId) => {
                                    if (!facilityIdsTemp.includes(facId)) {
                                        facilityIdsTemp.push(facId);
                                    }
                                });
                            } else {
                                // If company is unselected
                                // Remove company Id
                                if (index > -1) {
                                    facilityIdsTemp.splice(index, 1);
                                }
                                facilitiesIn.forEach((facId) => {
                                    let index = facilityIdsTemp.indexOf(facId);
                                    if (index > -1) {
                                        facilityIdsTemp.splice(index, 1);
                                    }
                                });
                            }
                        } else {
                            isAdded ? facilityIdsTemp.push(companyChanged._id) : facilityIdsTemp.splice(index, 1);
                        }
                    } else {
                        // If facility is changed
                        let companyId = facilityChanged.parent_id;
                        let facilitiesIn = [];
                        facilities.forEach((fac) => {
                            if (fac.parent_id === companyId) {
                                facilitiesIn.push(fac._id);
                            }
                        });
                        // If facility Id is selected
                        if (isAdded) {
                            // Add facility Id
                            facilityIdsTemp.push(facilityChanged._id);
                            if (!filters.facility_id.includes(companyId)) {
                                facilityIdsTemp.push(companyId);
                            }
                        } else {
                            // If facility Id is unselected
                            // Remove facility Id
                            let index = facilityIdsTemp.indexOf(facilityChanged._id);
                            if (index > -1) {
                                facilityIdsTemp.splice(index, 1);
                            }
                            // Remove company Id
                            let facilitiesInFilters = [];
                            facilitiesIn.forEach((fac) => {
                                if (facilityIdsTemp.includes(fac)) {
                                    facilitiesInFilters.push(fac);
                                }
                            });
                            if (facilitiesInFilters.length === 0) {
                                index = facilityIdsTemp.indexOf(companyId);
                                if (index > -1) {
                                    facilityIdsTemp.splice(index, 1);
                                }
                            }
                        }
                    }
                    filters.facility_id = _.cloneDeep(facilityIdsTemp);
                    window.localStorage.setItem('FACILITY_ID', JSON.stringify(filters.facility_id));
                }
                break;
            }
            default:
                break;
        }

        this.setState({ activeGridView });
        this.loadGridData(filters);
    };

    autoFitActions = (params) => {

        const api = (params && params.api) || this.gridApi;

        if (api && api.autoSizeColumns) setTimeout(() => { try { api.autoSizeColumns(['actions'], false); } catch (e) { /* ignore */ } }, 60);

    };


    onGridReady = (params) => {
        let { defaultGridView } = this.state;
        this.gridApi = params.api;
        defaultGridView.columns = this.gridApi.getColumnState();
        this.setState({ defaultGridView });
    };

    checkRealFacilities = (searchFilters) => {
        let realFacilities = [];
        searchFilters.facility_id.map((facilityId) => {
            if (this.state.facilities.find((facility) => facility._id === facilityId)) {
                realFacilities.push(facilityId);
            }
            return null;
        });
        return realFacilities;
    };

    loadGridData = (searchFilterConditions = null) => {
        let searchFilters;
        if (!searchFilterConditions) {
            searchFilters = this.state.activeGridView.search_filters;
        } else {
            searchFilters = searchFilterConditions;
        }
        searchFilters.facility_id = this.checkRealFacilities(searchFilters);
        if (this.gridApi) {
            this.gridApi.showLoadingOverlay();
        }
        failedNotificationReports(searchFilters).then((response) => {
            let rowData = response.data.filter((item) => {
                if (!['DELIVERED_TO_PATIENT', 'SENT_TO_FACILITY'].includes(item.notification_state)) {
                    return true;
                }
                return false;
            });
            this.setState({ rowData: rowData });
            if (!rowData.length) {
                this.gridApi.showNoRowsOverlay();
            } else {
                this.gridApi.hideOverlay();
            }
            this.loadGridSchema();
        });
    };

    loadGridSchema = () => {
        let { activeGridView } = this.state;
        const columnState = activeGridView.columns;
        if (columnState && columnState.length > 0 && activeGridView.name !== 'Default') {
            this.gridApi.applyColumnState({
                state: columnState,
                applyOrder: true
            });
        } else {
            this.gridApi.resetColumnState();
            activeGridView.columns = this.gridApi.getColumnState();
            this.setState({ activeGridView });
        }
        this.pageSizeChange(activeGridView.page_size);
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'Failed_Notification_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'Failed Notifications'
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.FailedSMSEmailReportGridExported,
            user_id: userData._id,
            user_name: userData.user_name + ' (' + userData.role + ')',
            update_string: auditEnums.EVENTTYPES.FailedSMSEmailReportGridExported
        };
        createAudit(auditData);
    };

    onPageSizeChanged = (e) => {
        this.pageSizeChange(e.target.value);
    };

    pageSizeChange = (pageSize) => {
        let { activeGridView } = this.state;
        activeGridView.page_size = pageSize;
        this.setState({ activeGridView });
    };

    resetState = () => {
        this.pageSizeChange(settingConstants.DEFAULT_PAGESIZE);
        this.clearFilter();
    };

    clearFilter = () => {
        let { activeGridView, defaultGridView, user_role, facilities } = this.state;
        let viewInfoPrev = _.cloneDeep(activeGridView);
        activeGridView = _.cloneDeep(defaultGridView);
        if (viewInfoPrev._id) {
            activeGridView._id = viewInfoPrev._id;
        }
        activeGridView.name = viewInfoPrev.name;
        this.gridApi.setFilterModel(null);

        if (
            user_role &&
            (user_role.toLowerCase().trim() === 'superadmin' || user_role.toLowerCase().trim() === 'admin')
        ) {
            activeGridView.search_filters.facility_id = this.facilityIds;
        } else {
            if (facilities.length > 1) {
                activeGridView.search_filters.facility_id = this.facilityIds;
            } else {
                activeGridView.search_filters.facility_id = facilities[0]._id;
            }
        }
        window.localStorage.removeItem('FACILITY_ID');

        this.setState({
            activeGridView,
            quickFilterText: ''
        });
        document.getElementById('reset-form').value = '';
        this.loadGridData(activeGridView.search_filters);
    };

    openCreateView = (isCreateDefault) => {
        this.setState({
            showNameModal: true,
            isCreateDefault,
            isRenameView: false
        });
    };

    saveView = () => {
        let { isRenameView, newViewName } = this.state;
        if (isRenameView) {
            this.renameView(newViewName);
        } else {
            this.createView(newViewName);
        }
    };

    updateView = () => {
        let { activeGridView, userSetting } = this.state;
        activeGridView.columns = this.gridApi.getColumnState();
        let viewInfo = {
            _id: userSetting._id,
            grid_view: activeGridView
        };
        Swal.fire({
            title: 'Save Current Dates?',
            text: 'Do you want to save the current dates?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            },
            allowOutsideClick: false
        }).then((result) => {
            activeGridView.date_save = result.isConfirmed ? true : false;
            updateGridViewService(viewInfo).then((response) => {
                if (response.status === 200) {
                    userSetting = response.data;
                    userSetting.grid_views = this.initDateRange(userSetting.grid_views);
                    this.setState({ userSetting });
                    toastr.success('View saved successfully.');
                    this.handleClose();
                } else {
                    toastr.error('Error');
                }
            });
        });
    };

    createView = (newName) => {
        let newGridView = {};
        let { activeGridView, defaultGridView, userSetting, isCreateDefault, isDateSave } = this.state;
        let isNameExists = userSetting.grid_views.some((view) => view.name === newName);
        if (!isNameExists) {
            if (isCreateDefault) {
                newGridView = _.cloneDeep(defaultGridView);
                newGridView.search_filters.facility_id = this.facilityIds;
            } else {
                newGridView = _.cloneDeep(activeGridView);
                delete newGridView._id;
            }
            newGridView.name = newName;
            newGridView.date_save = isDateSave;
            if (isDateSave) {
                newGridView.search_filters.from_date = _.cloneDeep(activeGridView.search_filters.from_date);
                newGridView.search_filters.to_date = _.cloneDeep(activeGridView.search_filters.to_date);
            } else {
                newGridView.search_filters.from_date = _.cloneDeep(defaultGridView.search_filters.from_date);
                newGridView.search_filters.to_date = _.cloneDeep(defaultGridView.search_filters.to_date);
            }
            userSetting.grid_views.push(newGridView);
            this.saveState(userSetting);
        } else {
            toastr.warning('Same name exists.');
        }
    };

    updateViews = (gridViews) => {
        let { userSetting } = this.state;
        userSetting.grid_views = gridViews;
        this.setState({ isUpdateViews: true });
        this.saveState(userSetting);
    };

    saveState = (gridSetting) => {
        saveOrderSettings(gridSetting).then((response) => {
            if (response.status === 200) {
                let { isUpdateViews, activeGridView } = this.state;
                let userSetting = response.data;
                userSetting.grid_views = this.initDateRange(userSetting.grid_views);
                if (!isUpdateViews) {
                    let lastGridViewIndex = userSetting.grid_views.length - 1;
                    activeGridView = _.cloneDeep(userSetting.grid_views[lastGridViewIndex]);
                    window.localStorage.setItem('VIEW_FAILED_SMS_EMAIL_REPORTS', activeGridView._id);
                    this.setState({
                        activeGridView,
                        userSetting,
                        isCreateDefault: true
                    });
                    this.loadGridData(activeGridView.search_filters);
                    if (activeGridView.name !== 'Default') toastr.success('Settings saved successfully.');
                } else {
                    this.setState({
                        activeGridView,
                        userSetting,
                        isUpdateViews: false
                    });
                }

                this.handleClose();
            } else if (response.status === 403) {
                toastr.error(response.message);
            } else {
                toastr.error('Error');
            }
        });
    };

    handleClose = () => {
        this.setState({
            showNameModal: false,
            newViewName: '',
            isDateSave: false
        });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    renameActiveView = () => {
        let { activeGridView } = this.state;
        this.setState({ newViewName: activeGridView.name });
        this.openRenameView(activeGridView._id);
    };

    openRenameView = (selectedViewId) => {
        let { userSetting } = this.state;
        let selectedView = userSetting.grid_views.find((view) => view._id === selectedViewId);
        this.setState({
            isRenameView: true,
            showNameModal: true,
            selectedViewId,
            newViewName: selectedView.name
        });
    };

    toggleItem = (name) => {
        this.setState({ [name]: !this.state[name] });
    };

    renameView = () => {
        let { selectedViewId, userSetting, newViewName } = this.state;
        let isNameExists = userSetting.grid_views.some(
            (view) => view.name === newViewName && view._id !== selectedViewId
        );
        if (isNameExists) {
            toastr.warning('Same name exists.');
        } else {
            let viewInfo = {
                _id: userSetting._id,
                view_id: selectedViewId,
                view_name: newViewName
            };
            renameGridViewService(viewInfo).then((response) => {
                if (response.status === 200) {
                    userSetting = response.data;
                    userSetting.grid_views = this.initDateRange(userSetting.grid_views);
                    let activeGridView = _.cloneDeep(
                        userSetting.grid_views.find((view) => view._id === selectedViewId)
                    );
                    this.setState({
                        userSetting,
                        activeGridView,
                        isRenameView: false
                    });
                    toastr.success('View renamed successfully.');
                    this.handleClose();
                } else {
                    toastr.error('Error');
                }
            });
        }
    };

    deleteActiveView = () => {
        let { activeGridView } = this.state;
        this.openDeleteView(activeGridView._id);
    };

    openDeleteView = (viewId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this view!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteView(viewId);
            }
        });
    };

    deleteView = (viewId) => {
        let { userSetting } = this.state;
        const viewInfo = {
            _id: userSetting._id,
            view_id: viewId
        };
        deleteGridViewService(viewInfo).then((response) => {
            if (response.status === 200) {
                userSetting = response.data;
                let newActiveGridView = userSetting.grid_views[0];
                this.setState({ userSetting });
                this.handleTabChange(newActiveGridView._id);
                toastr.success('View deleted successfully.');
                this.handleClose();
            } else {
                toastr.error('Error');
            }
        });
    };

    handleKeyDown = (e) => {
        if (e.which === 13) {
            e.preventDefault();
            this.saveView();
        }
    };

    openAllGridViews = (isOpen) => {
        this.setState({ showAllGridViews: isOpen });
    };

    render() {
        const { showAllGridViews, newViewName, activeGridView, isCreateDefault, isRenameView, userSetting, showNameModal

 } =
            this.state;
        let columnDefs = /audit/.test(getUserRole().toLowerCase())
            ? this.state.columnDefs.filter((x) => x.headerName !== 'Actions')
            : this.state.columnDefs;
        return (
            <div className="clinic-contain">
                <ReportsSearchMenu
                    onIsArchivedInformation={(event) => {
                        this.onIsArchivedInformation(event);
                    }}
                    isArchived={this.state.isArchived}
                    facilityId={activeGridView.search_filters.facility_id}
                    handleFiltersChange={this.handleFiltersChange}
                    handleDateFiltersChange={this.handleDateFiltersChange}
                    updateDateRange={this.updateDateRange}
                    facilities={this.state.facilities}
                    from_date={activeGridView.search_filters.from_date}
                    to_date={activeGridView.search_filters.to_date}
                    date_range={activeGridView.search_filters.dateRange}
                    onFilterTextChange={this.onFilterTextChange}
                    stateReportsType={activeGridView.search_filters.stateReportsType}
                    clearFilter={this.clearFilter}
                    onPageSizeChanged={this.onPageSizeChanged}
                    page_size={activeGridView.page_size}
                    resetState={this.resetState}
                    onBtnExport={this.onBtnExport}
                    user_role={this.state.user_role}
                    gridViews={userSetting.grid_views}
                    activeGridView={activeGridView}
                    openCreateView={this.openCreateView}
                    handleTabChange={this.handleTabChange}
                    updateView={this.updateView}
                    openAllGridViews={this.openAllGridViews}
                    renameActiveView={this.renameActiveView}
                    deleteActiveView={this.deleteActiveView}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 380px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    onFirstDataRendered={this.autoFitActions}
                                    onRowDataUpdated={this.autoFitActions}
                                    rowData={this.state.rowData}
                                    components={this.state.components}
                                    pagination={true}
                                    paginationPageSize={activeGridView.page_size}
                                    paginationNumberFormatter={this.state.paginationNumberFormatter}
                                    paginationPageSizeSelector={false}
                                    excelStyles={this.state.excelStyles}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>

                {/* Create modal */}
                <ModalStyled show={showNameModal} onHide={this.handleClose} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {isRenameView
                                ? 'Update Name'
                                : 'Create a new ' + (isCreateDefault ? '' : ' saved') + ' view'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-12">
                                <label>
                                    Name <span className="text-danger"> *</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="newViewName"
                                    value={newViewName}
                                    onChange={this.handleChange}
                                    onKeyDown={this.handleKeyDown}
                                />
                            </div>
                            {!this.state.isRenameView && (
                                <div className="col-12 mt-3">
                                    <MenuItem
                                        onClick={() => this.toggleItem('isDateSave')}
                                        style={{ paddingLeft: '0px' }}
                                    >
                                        <Checkbox checked={this.state.isDateSave} /> Save Current Dates
                                    </MenuItem>
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.saveView} disabled={!this.state.newViewName}>
                            Save
                        </Button>
                    </Modal.Footer>
                </ModalStyled>

                <ModalStyled
                    show={showAllGridViews}
                    onHide={() => this.openAllGridViews(false)}
                    className="modal-container custom-map-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>All saved views</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AllGridViews
                            gridViews={userSetting.grid_views}
                            openRenameView={this.openRenameView}
                            openDelteView={this.openDeleteView}
                            updategridViews={this.updategridViews}
                            updateViews={this.updateViews}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}

export default ClinicFailedNotificationReportsGrid;
